import { useState, Fragment } from "react";
export default function DropDownBanner({ children, data }) {
  const [show, setShow] = useState(false);
  return (
    <Fragment>
      {show && (
        <div
          onClick={() => setShow(false)}
          className="absolute w-screen h-screen"
        ></div>
      )}
      <div className="relative cursor-pointer" onClick={() => setShow(!show)}>
        {children}
        {show && (
          <div className="absolute grid gap-2 p-4 overflow-scroll rounded-lg h-52 bg-stone-800">
            {data.map((item) =>
              Object.keys(item).map((key, idx) => (
                <div key={idx} className="text-xs">
                  <p className="text-stone-400">{key}:</p>
                  <p className="text-stone-200">{item[key]}</p>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </Fragment>
  );
}
